import cn from 'classnames';

import styles from './styles.module.scss';

type InputBadge = {
  label: string;
  value: number;
};

type Props = {
  badges: InputBadge[];
  currentValue: number;
  onSelect: (value: number) => void;
};

export const BadgeList = ({ badges, currentValue, onSelect }: Props) => (
  <div className={styles.tagContainer}>
    {badges.map(({ label, value }) => (
      <div
        key={label}
        onClick={() => onSelect(value)}
        className={cn(styles.badge, {
          [styles.inactive]: currentValue !== value,
          [styles.active]: currentValue === value,
        })}
      >
        {label}
      </div>
    ))}
  </div>
);
